import { render, staticRenderFns } from "./tlQa.vue?vue&type=template&id=7adb5ea1&scoped=true&"
import script from "./tlQa.vue?vue&type=script&lang=js&"
export * from "./tlQa.vue?vue&type=script&lang=js&"
import style0 from "./tlQa.vue?vue&type=style&index=0&id=7adb5ea1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb5ea1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adb5ea1')) {
      api.createRecord('7adb5ea1', component.options)
    } else {
      api.reload('7adb5ea1', component.options)
    }
    module.hot.accept("./tlQa.vue?vue&type=template&id=7adb5ea1&scoped=true&", function () {
      api.rerender('7adb5ea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/quality/tlQa.vue"
export default component.exports